/** Location name reserved for the implicit project root. */
export const FORBIDDEN_SITE_NAME = 'Site'

/** Validation message shown when the reserved project-root name is entered. */
export const FORBIDDEN_SITE_NAME_MESSAGE = `'Site' name is prohibited`
